<h2 mat-dialog-title>Edición de Gastos de {{input?.ExpensaCabecera?.ComunidadNombre}} del Período {{input?.ExpensaCabecera?.ExpensaPeriodo}}</h2>

<div mat-dialog-content>

    <!-- GASTOS FUERA DEL PERIODO ACTUAL -->
    <mat-expansion-panel>

      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon style="margin-top: -3px;">attach_money</mat-icon> Buscar Gastos Pendientes Fuera del Período Actual
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <form [formGroup]="formGroup">

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin-bottom: 10px;">

          <div fxFlex=33 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isTipoGastoComunidadSearching">Tipos de Gasto</mat-label>
              <mat-label *ngIf="isTipoGastoComunidadSearching">Cargando...</mat-label>
              <mat-select formControlName="TipoGastoId">
                <mat-option>Todos</mat-option>
                <mat-option *ngFor="let s of comunidadTipoGastoList" [value]="s.Id">{{s.TipoGasto}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex=33 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isServicioSearching">Servicios</mat-label>
              <mat-label *ngIf="isServicioSearching">Cargando...</mat-label>
              <mat-select formControlName="Servicios" multiple [compareWith]="compareServicios">
                <mat-option *ngFor="let s of serviciosList" [value]="s.Id">{{s.Nombre}} <!-- - {{s.CategoriaGastoNombre}}--></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex=33 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isMonedaSearching">Moneda</mat-label>
              <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
              <mat-select formControlName="MonedaId">
                <mat-option>Todas</mat-option>
                <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxFlex=33 fxFlex.xs=100 class="flex-item" style="margin-top: 30px !important;">
            <mat-checkbox [(ngModel)]="verOtrosGastosPendientes" [ngModelOptions]="{standalone: true}" color="primary">
            </mat-checkbox>
            <mat-label style="margin-left: 5px;">Ver Gastos Pendientes de Otros Períodos</mat-label>
          </div>
          <ng-container *ngIf="verOtrosGastosPendientes">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Fecha de Gasto Desde</mat-label>
                <input matInput [matDatepicker]="fechaGastoDesdePicker" formControlName="FechaGastoDesde" (click)="fechaGastoDesdePicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoDesdePicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaGastoDesde')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaGastoDesdePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Fecha de Gasto Hasta</mat-label>
                <input matInput [matDatepicker]="fechaGastoHastaPicker" formControlName="FechaGastoHasta" (click)="fechaGastoHastaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoHastaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaGastoHasta')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaGastoHastaPicker></mat-datepicker>
              </mat-form-field>
            </div>

          </ng-container>

        </div>

        <div fxLayout="row-reverse stretch" fxLayout.xs="column" style="margin-bottom: 10px;">
          <button mat-raised-button (click)="onGastoSearch()" [disabled]="isSaving || isSimulating" color="primary" class="zb-button" style="margin-right: 5px;">Buscar</button>
        </div>

      </form>

      <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

      <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">

        <mat-label *ngIf="isGastoSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>

        <mat-tab-group>

          <mat-tab label="{{'Comunidad' | translate}}">

            <ejs-grid #gastosComunidadGrid [dataSource]='gastosComunidadPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
              [selectionSettings]='gastosSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' (rowSelected)='onGastoComunidadRowSelected($event)'
              (rowDeselected)='onGastoComunidadRowDeselected($event)' (dataBound)='onGastoComunidadDataBound($event)'>
              <e-columns>
                <e-column type='checkbox' width='50'></e-column>
                <e-column field='FechaGasto' headerText='Fecha' width='90'>
                  <ng-template #template let-data>
                    {{data.FechaGasto | date:'dd/MM/yyyy'}}
                  </ng-template>
                </e-column>
                <e-column field='TipoGasto' headerText='Tipo Gasto' width='100'></e-column>
                <e-column field='ServicioGasto' headerText='Servicio' width='100'></e-column>
                <e-column field='Detalle' headerText='Detalle' width='130'></e-column>
                <e-column field='Importe' headerText='Importe' width='90' textAlign='Right'>
                  <ng-template #template let-data>
                    {{data.Moneda}} {{data.Importe | number: '1.2-2'}}
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>

          </mat-tab>

          <mat-tab label="{{'UnidadFuncional' | translate}}">

            <ejs-grid #gastosUfsGrid [dataSource]='gastosUfPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
              [selectionSettings]='gastosSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' (rowSelected)='onGastoUfRowSelected($event)'
              (rowDeselected)='onGastoUfRowDeselected($event)' (dataBound)='onGastoUfDataBound($event)'>
              <e-columns>
                <e-column type='checkbox' width='50'></e-column>
                <e-column field='FechaGasto' headerText='Fecha' width='90'>
                  <ng-template #template let-data>
                    {{data.FechaGasto | date:'dd/MM/yyyy'}}
                  </ng-template>
                </e-column>
                <e-column field='UnidadFuncionalCodigo' headerText='Cód.' width='100'></e-column>
                <e-column field='TipoGasto' headerText='Tipo Gasto' width='100'></e-column>
                <e-column field='ServicioGasto' headerText='Servicio' width='100'></e-column>
                <e-column field='Detalle' headerText='Detalle' width='130'></e-column>
                <!-- <e-column field='Moneda' headerText='Moneda' width='10%'></e-column> -->
                <e-column field='Importe' headerText='Importe' width='90' textAlign='Right'>
                  <ng-template #template let-data>
                    {{data.Moneda}} {{data.Importe | number: '1.2-2'}}
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>

          </mat-tab>

        </mat-tab-group>

      </div>

    </mat-expansion-panel>

    <br/>

    <hr style="margin:20px 0px; width: 100%;">

    <!-- GASTOS INCLUIDOS EN EL PERIODO ACTUAL -->
    <mat-expansion-panel [expanded]="true">

      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon style="margin-top: -3px;">attach_money</mat-icon> Gastos del Período Actual
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">

        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-tab-group>

            <mat-tab label="{{'Comunidad' | translate}}">

              <div fxLayout="row stretch" fxLayout.xs="column">

                <ejs-grid #gastosComunidadPeriodoGrid [dataSource]='gastosComunidadPeriodoList' [allowPaging]="gastosGridAllowPaging" [allowSorting]="true" [toolbar]='toolbarOptions'
                  [selectionSettings]='gastosSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
                  <e-columns>
                    <e-column headerText='' width='40'>
                      <ng-template #template let-data>
                        <a style="cursor: pointer;" (click)="deleteGastoComunidadPeriodo(data)" title="Quitar el gasto del período actual">
                          <i class="fa fa-trash fa-1x"></i>
                        </a>
                      </ng-template>
                    </e-column>
                    <e-column field='FechaGasto' headerText='Fecha' width='90'>
                      <ng-template #template let-data>
                        {{data.FechaGasto | date:'dd/MM/yyyy'}}
                      </ng-template>
                    </e-column>
                    <e-column field="TipoGasto" headerText='Tipo Gasto' width=100></e-column>
                    <e-column field="ServicioGastoNombre" headerText='Rubro' width=100>
                      <ng-template #template let-data>
                        {{data.ServicioGastoNombre?.length > 0 ? data.ServicioGastoNombre : data.ServicioGasto}}
                      </ng-template>
                    </e-column>
                    <e-column field='Detalle' headerText='Detalle' width='130'></e-column>
                    <e-column field="Importe" headerText='Importe' width=100 textAlign='Right'>
                      <ng-template #template let-data>
                        {{data.MonedaNombre?.length > 0 ? data.MonedaNombre : data.Moneda}} {{data.Importe | number:'1.2-2'}}
                      </ng-template>
                    </e-column>
                  </e-columns>

                  <ng-template #rowTemplate let-data>
                    <tr class="e-row" [ngStyle]="{ 'background-color': data.Nuevo === true ? '#ffeb91' : 'white'}">
                      <td class="e-rowcell">
                        <a style="cursor: pointer;" (click)="deleteGastoComunidadPeriodo(data)" title="Quitar el gasto del período actual">
                          <i class="fa fa-trash fa-1x"></i>
                        </a>
                      </td>
                      <td class="e-rowcell">{{data.FechaGasto | date:'dd/MM/yyyy'}}</td>
                      <td class="e-rowcell">{{data.TipoGasto}}</td>
                      <td class="e-rowcell">{{data.ServicioGastoNombre?.length > 0 ? data.ServicioGastoNombre : data.ServicioGasto}}</td>
                      <td class="e-rowcell">{{data.Detalle}}</td>
                      <td class="e-rowcell" align="right">{{data.MonedaNombre?.length > 0 ? data.MonedaNombre : data.Moneda}} {{data.Importe | number:'1.2-2'}}</td>
                    </tr>
                  </ng-template>

                </ejs-grid>

              </div>

              <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end" class="flex-item" style="font-weight: bold; margin-top: 5px;">
                  Cantidad Total: {{cantidadGastosComunidadTotalSeleccionado}} - Monto Total: ${{gastosComunidadTotalSeleccionado | number:'1.2-2'}}
                </div>
              </div>

            </mat-tab>

            <mat-tab label="{{'UnidadFuncional' | translate}}">

              <div fxLayout="row stretch" fxLayout.xs="column">

                <ejs-grid #gastosUfsPeriodoGrid [dataSource]='gastosUfPeriodoList' [allowPaging]="gastosGridAllowPaging" [allowSorting]="true" [toolbar]='toolbarOptions'
                  [selectionSettings]='gastosSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
                  <e-columns>
                    <e-column headerText='' width='40'>
                      <ng-template #template let-data>
                        <a style="cursor: pointer;" (click)="deleteGastoUfPeriodo(data)" title="Quitar el gasto del período actual">
                          <i class="fa fa-trash fa-1x"></i>
                        </a>
                      </ng-template>
                    </e-column>
                    <e-column field='FechaGasto' headerText='Fecha' width='90'>
                      <ng-template #template let-data>
                        {{data.FechaGasto | date:'dd/MM/yyyy'}}
                      </ng-template>
                    </e-column>
                    <e-column field='UnidadFuncionalCodigo' headerText='Cód. UF' width='100'></e-column>
                    <e-column field="TipoGasto" headerText='Tipo Gasto' width=100></e-column>
                    <e-column field="ServicioGastoNombre" headerText='Rubro' width=100>
                      <ng-template #template let-data>
                        {{data.ServicioGastoNombre?.length > 0 ? data.ServicioGastoNombre : data.ServicioGasto}}
                      </ng-template>
                    </e-column>
                    <e-column field='Detalle' headerText='Detalle' width='130'></e-column>
                    <e-column field="Importe" headerText='Importe' width=100 textAlign='Right'>
                      <ng-template #template let-data>
                        {{data.MonedaNombre?.length > 0 ? data.MonedaNombre : data.Moneda}} {{data.Importe | number:'1.2-2'}}
                      </ng-template>
                    </e-column>
                  </e-columns>

                  <ng-template #rowTemplate let-data>
                    <tr class="e-row" [ngStyle]="{ 'background-color': data.Nuevo === true ? '#ffeb91' : 'white'}">
                      <td class="e-rowcell">
                        <a style="cursor: pointer;" (click)="deleteGastoUfPeriodo(data)" title="Quitar el gasto del período actual">
                          <i class="fa fa-trash fa-1x"></i>
                        </a>
                      </td>
                      <td class="e-rowcell">{{data.FechaGasto | date:'dd/MM/yyyy'}}</td>
                      <td class="e-rowcell">{{data.UnidadFuncionalCodigo}}</td>
                      <td class="e-rowcell">{{data.TipoGasto}}</td>
                      <td class="e-rowcell">{{data.ServicioGastoNombre?.length > 0 ? data.ServicioGastoNombre : data.ServicioGasto}}</td>
                      <td class="e-rowcell">{{data.Detalle}}</td>
                      <td class="e-rowcell" align="right">{{data.MonedaNombre?.length > 0 ? data.MonedaNombre : data.Moneda}} {{data.Importe | number:'1.2-2'}}</td>
                    </tr>
                  </ng-template>

                </ejs-grid>

              </div>

              <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end" class="flex-item" style="font-weight: bold; margin-top: 5px;">
                  Cantidad Total: {{cantidadGastosUfTotalSeleccionado}} - Monto Total: ${{gastosUfTotalSeleccionado | number:'1.2-2'}}
                </div>
              </div>

            </mat-tab>

          </mat-tab-group>

        </mat-expansion-panel>

      </div>

      <hr width="100%">

      <!-- TOTALIZADORES DE GASTOS -->
      <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label class="text-style" style="text-align: center; width: 100%;"><b>Cantidad Total</b>: {{cantidadGastosTotalSeleccionado}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label class="text-style" style="text-align: center; width: 100%;"><b>Monto Total</b>: ${{gastosTotalSeleccionado | number:'1.2-2'}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>
      </div>

    </mat-expansion-panel>

</div>

<br/>

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isSaving || isSimulating" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
    <button mat-raised-button (click)="onSimular()" [disabled]="isSaving || isSimulating" class="zb-button">{{isSimulating ? 'Simulando...' : 'Simular'}}</button>
    <button mat-raised-button color="warn" (click)="onCancel()" class="zb-button">Cancelar</button>
  </div>
</div>
